import { Menu as MenuPrimitive } from '@base-ui/react/menu';

// The shadcn registry has no link item, so it lives outside components/ui where regenerating would delete it.
export function DropdownMenuLinkItem({ ...props }: MenuPrimitive.LinkItem.Props) {
  return <MenuPrimitive.LinkItem data-slot='dropdown-menu-link-item' {...props} />;
}
